import { CSSProperties, FC, useEffect, useRef, useState } from "react"
import { v4 } from "uuid"
import { HorizontalScrollBox } from "../../Orders/Components/HorizontalScrollBox/HorizontalScrollBox"
import { cls } from "../cls"
import style from "./TabbedInlineView.module.css"

export type TabbedInlineViewProps = {
	tabs: InlineViewTab[]
	wrapperStyles?: CSSProperties
}

export type InlineViewTab = {
	id: string
	name: string
	afterNameElement?: JSX.Element | null
	content: JSX.Element | null
	contentWrapperClass?: string
	disabled?: boolean
	iconElement: JSX.Element
	onClick?: (tabId: string) => void
}

export const TabbedInlineView: FC<TabbedInlineViewProps> = (props: TabbedInlineViewProps) => {
	const componentId = useRef(v4())

	const [selectedTabId, setSelectedTabId] = useState<string | null>(props.tabs?.[0]?.id || null)

	const selectedTab = !!selectedTabId ? props.tabs.find((x) => x.id === selectedTabId) : null

	useEffect(() => {
		if (!!selectedTabId && !props.tabs.find((x) => x.id === selectedTabId)) {
			setSelectedTabId(props.tabs?.[0]?.id || null)
		}
	}, [props.tabs])

	return (
		<div className={style.wrapper} style={props.wrapperStyles}>
			<HorizontalScrollBox
				className={style.horizontalScrollWrapper}
				cellClassName={style.horizontalScroll}
				key={`tabbedInlineView-${componentId.current}`}>
				{props.tabs.map((tab) => {
					return (
						<div
							key={componentId.current + tab.id}
							className={cls(
								style.tab,
								{
									[style.selectedTab]: selectedTabId === tab.id,
								},
								{
									[style.disabled]: tab.disabled === true,
								},
							)}
							onClick={() => {
								if (tab.disabled) {
									return
								}

								if (selectedTabId !== tab.id) {
									const onClick = tab.onClick

									if (onClick) {
										onClick(tab.id)
									}

									setSelectedTabId(tab.id)
								}
							}}>
							<span>{tab.iconElement}</span>
							<span>{tab.name}</span>
							{tab.afterNameElement || null}
						</div>
					)
				})}
				<div className={style.lastFillerTab} />
			</HorizontalScrollBox>
			<div className={cls(style.tabContent, selectedTab?.contentWrapperClass)}>{selectedTab?.content}</div>
		</div>
	)
}
